import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  Field,
  getFormValues,
  reduxForm,
  change,
  arrayRemoveAll,
  arrayPush,
  reset,
} from 'redux-form';
import {
  setSelectedOutletsModal,
  onClickCancelModalAssignOutlet,
  hideModalAssignOutlets,
  showModalConfirmAssignOutlets,
  onChangeSearchAvailableOutlets,
} from 'actions/setting/bankAccount';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import NoDataAndLoading from 'components/NoDataAndLoading';
import styles from './style.css';

class AssignOutletsModal extends React.Component {
  render() {
    const {
      showModalAssignOutlets,
      showLoadingSpinnerModal,
      availableOutlets,
      bankAccountForm,
      assignOutletsForm,
    } = this.props;

    let selectedCount = 0;
    if (assignOutletsForm !== undefined) {
      assignOutletsForm.outlets.forEach(outlet => {
        if (outlet.selected) {
          selectedCount++;
        }
      });
    }

    return (
      <Modal
        show={showModalAssignOutlets}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header>
          <Modal.Title>
            <span>Assign Outlet</span>
          </Modal.Title>
        </Modal.Header>

        <form>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <p>
                  <strong>Assign to</strong>
                </p>
                <div className={`panel panel-default ${styles.panel}`}>
                  <div className="panel-body">
                    <div className="col-xs-6 pl-0px">
                      <p className="mb-5px">
                        <strong>Bank Name</strong>
                      </p>
                      <p>
                        <small>
                          {bankAccountForm !== null
                            ? bankAccountForm.bankName
                            : ''}
                        </small>
                      </p>
                    </div>
                    <div className="col-xs-6 pl-0px">
                      <p className="mb-5px">
                        <strong>Account Number</strong>
                      </p>
                      <p>
                        <small>
                          {bankAccountForm !== null
                            ? bankAccountForm.accountNumber
                            : ''}
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Field
              component={SearchBar}
              className={`${styles['field-wrapper-search']}`}
              placeholder="Search"
              onChange={this._onChangeSearchAvailableOutlets}
              name="search"
            />

            <div className={`${styles['table-wrapper-assign-outlets']}`}>
              <table className={`${styles['table-header']}`}>
                <thead>
                  <tr>
                    <th width="60%">
                      <label className={`${styles['checkbox-custom']}`}>
                        <Field
                          type="checkbox"
                          component="input"
                          name="outletSelectAll.selected"
                          onChange={this._onSelectAll}
                        />
                        <span className={`${styles.checkbox}`} />
                        <span>Select all</span>
                      </label>
                    </th>
                    <th width="40%" className="pull-right">
                      Assigned to
                    </th>
                  </tr>
                </thead>
              </table>

              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerModal}
                noDataToDisplay={availableOutlets.length === 0}
                title="No Data To Display"
                heightClass={`${styles['table-no-data-assign-outlets']}`}
              />
              <div className={`${styles['table-content-wrapper']}`}>
                {availableOutlets.length > 0 && (
                  <table className={styles['table-content']}>
                    <tbody>
                      {availableOutlets.map(availableOutlet => {
                        const outletId = availableOutlet.id;
                        return (
                          <tr key={outletId}>
                            <td width="60%">
                              <label className={`${styles['checkbox-custom']}`}>
                                <Field
                                  id={`${outletId}`}
                                  type="checkbox"
                                  component="input"
                                  name={`outlets[${outletId}].selected`}
                                  onChange={this._onSelectOne}
                                />
                                <span
                                  className={`${styles.checkbox} ${
                                    styles['checkbox-select-one']
                                  }`}
                                />
                                <span
                                  className={`${styles['checkbox-label-body']}`}
                                >
                                  {availableOutlet.name}
                                </span>
                              </label>
                            </td>
                            <td width="40%">
                              <span>
                                <span className="pull-right">
                                  {availableOutlet.bankName !== null
                                    ? availableOutlet.bankName
                                    : 'Unassigned'}
                                </span>
                                <br />
                                <span
                                  className={`pull-right ${
                                    styles['text-light-grey']
                                  }`}
                                >
                                  {availableOutlet.accountNumber !== null
                                    ? availableOutlet.accountNumber
                                    : '-'}
                                </span>
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <span className="pull-left">
              Selected:{' '}
              <strong>
                {selectedCount > 0 ? `${selectedCount} Outlets` : 'None'}
              </strong>
            </span>
            <button
              className={`btn mr-10px ${styles['btn-outline-dark']} ${
                styles['btn-large']
              }`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-large']}`}
              disabled={selectedCount === 0}
              onClick={this._onClickAssign}
            >
              Assign
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onClickCancel = e => {
    if (
      this.props.bankAccountForm !== undefined &&
      this.props.bankAccountForm.outlets !== undefined
    ) {
      this.props.dispatch(
        setSelectedOutletsModal(this.props.bankAccountForm.outlets)
      );
    }
    this.props.dispatch(onClickCancelModalAssignOutlet());
    this.props.dispatch(reset('assignOutletsForm'));
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickAssign = e => {
    const { availableOutlets, assignOutletsForm } = this.props;

    let isAssignedOutletSelected = false;

    const selectedOutlets = availableOutlets
      .filter(
        availableOutlet =>
          assignOutletsForm.outlets[availableOutlet.id].selected
      )
      .map(availableOutlet => {
        if (
          availableOutlet.bankName !== null &&
          availableOutlet.accountNumber !== null
        ) {
          isAssignedOutletSelected = true;
        }
        return availableOutlet;
      });

    this.props.dispatch(hideModalAssignOutlets());

    if (isAssignedOutletSelected) {
      this.props.dispatch(showModalConfirmAssignOutlets());
    } else {
      this.props.dispatch(arrayRemoveAll('bankAccountForm', 'newOutlets'));
      selectedOutlets.forEach(selectedOutlet => {
        this.props.dispatch(
          arrayPush('bankAccountForm', 'newOutlets', selectedOutlet)
        );
      });
      this.props.dispatch(reset('assignOutletsForm'));
    }

    e.preventDefault();
    e.stopPropagation();
  };

  _onSelectAll = (e, selected) => {
    const { availableOutlets } = this.props;

    availableOutlets.forEach(availableOutlet => {
      this.props.dispatch(
        change(
          'assignOutletsForm',
          `outlets[${availableOutlet.id}].selected`,
          selected
        )
      );
    });

    this.props.dispatch(
      change('assignOutletsForm', 'outletSelectAll.selected', selected)
    );
  };

  _onSelectOne = (e, selected) => {
    const { availableOutlets, assignOutletsForm } = this.props;

    const outletId = parseInt(e.target.id);
    let selectedCount = selected ? 1 : 0;

    availableOutlets
      .filter(availableOutlet => availableOutlet.id !== outletId)
      .forEach(availableOutlet => {
        if (assignOutletsForm.outlets[availableOutlet.id].selected) {
          selectedCount++;
        }
      });

    const allSelected = selectedCount === availableOutlets.length;
    this.props.dispatch(
      change('assignOutletsForm', 'outletSelectAll.selected', allSelected)
    );
  };

  _onChangeSearchAvailableOutlets = (e, query) => {
    const { bankAccountForm, outlets, bankAccounts, banks } = this.props;

    this.props.dispatch(
      onChangeSearchAvailableOutlets(
        query,
        bankAccountForm.bankAccId,
        outlets,
        bankAccounts,
        banks
      )
    );
  };
}

function mapStateToProps(state) {
  const {
    availableOutlets,
    bankAccountDetail,
    bankAccountLists,
    bankList,
    outlets,
    showModalAssignOutlets,
    showLoadingSpinnerModal,
  } = state.setting.bankAccount;

  return {
    availableOutlets,
    bankAccount: bankAccountDetail,
    bankAccounts: bankAccountLists,
    banks: bankList,
    outlets,
    showModalAssignOutlets,
    showLoadingSpinnerModal,
    assignOutletsForm: getFormValues('assignOutletsForm')(state),
    bankAccountForm: getFormValues('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'assignOutletsForm',
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssignOutletsModal)
);
